import {AksjeeierEnkelModell, GruppeMedlemListeModell, MøtedeltakerModell} from "../tjenester/ressurser/generertNg2HttpKlient";

export function stemmevektAvvikerFraAntallAksjer(møtedeltakerer: MøtedeltakerModell[]): boolean {
    return møtedeltakerer.some(d => d.stemmevekt !== totaltAntallAksjerForMøtedeltaker(d));
}

export function totaltAntallAksjerForMøtedeltaker(deltaker: MøtedeltakerModell) {
    return deltaker.aksjeeierRepresentasjoner
      .map(aksjeeier => aksjeeier.naavaerendeBeholdning?.antall ?? 0)
      .reduce((a, b) => a + b, 0)
}

export function finnDeltakerSomRepresentererAksjeeier(deltakere: MøtedeltakerModell[], aksjeeier: AksjeeierEnkelModell): MøtedeltakerModell | null {
    return deltakere
      .find(deltaker => deltaker.aksjeeierRepresentasjoner.some(kandidat => kandidat.id == aksjeeier.id)) ?? null;
}

export function stemmeberettigedeMedlemmer(deltakere: MøtedeltakerModell[]): GruppeMedlemListeModell[] {
    return deltakere
      .filter(deltaker => deltaker.erStemmeberettiget)
      .map(deltaker => deltaker.medlem);
}

/**
 * Returnerer subset av angitt tilgjengeligMedlemmer liste bestående av medlemmer som finnes i angitt møtedeltaker-liste.
 *
 * Merk at dette settet vil avvike fra møte.deltakere ved at feks deaktiverte/anonymiserte
 * medlemmer som normal ikke vil være inkludert i tilgjengeligMedlemmer men som er med i
 * møte.deltakere ikke vil være med i returnert liste.
 */
export function medlemmerSomDeltarPåMøte(møtedeltakere: MøtedeltakerModell[], tilgjengeligMedlemmer: GruppeMedlemListeModell[]): GruppeMedlemListeModell[] {
    const møteMedlemmer = new Set(møtedeltakere.map(deltaker => deltaker.medlem.id));
    return tilgjengeligMedlemmer.filter(medlem => møteMedlemmer.has(medlem.id));
}
